import React from 'react';
import {
  QuizInputBaseProps,
  quizInputContainerStyles,
  quizLabelStyles,
  quizRequiredIndicatorStyles,
  getQuizInputClassName,
} from './QuizInputStyles';

interface Props extends QuizInputBaseProps {
  onChange: React.ChangeEventHandler<HTMLTextAreaElement> | undefined;
  rows?: number;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
}

export default function QuizInputTextarea({
  id,
  label,
  isRequired,
  placeholderText,
  value,
  onChange,
  rows = 4,
  disabled = false,
  isLoading = false,
  className,
}: Props) {
  const isDisabled = disabled || isLoading;
  return (
    <div className={quizInputContainerStyles}>
      {label && (
        <label htmlFor={id} className={quizLabelStyles}>
          {label}
          {isRequired && <span className={quizRequiredIndicatorStyles}>*</span>}
        </label>
      )}
      <div className='w-full flex flex-col relative'>
        <textarea
          id={id}
          placeholder={placeholderText ?? ''}
          className={`${getQuizInputClassName('textarea')} ${className ?? ''} ${
            isDisabled ? 'cursor-default pointer-events-none select-none' : ''
          }`}
          rows={rows}
          value={value}
          onChange={onChange}
          readOnly={isDisabled}
          aria-disabled={isDisabled}
          tabIndex={isDisabled ? -1 : 0}
        />
      </div>
    </div>
  );
}
